export const enum TableTennisKeyPeriod {
  FINISHED = 'finished',
  SET_AND_PERIOD = 'setAndPeriod',
}
